/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";

const Pagination = ({ offset, to, onSetOffset, limit, loading }) => {
  return (
    <div id="pagination" className="content">
      <div className="tblPag">
        <div className="row rowStretch">
          <div className="col col50">
            <span id="pagination-count" data-testid="pagination-count">{`${offset + 1}-${
              loading ? "?" : to + 1
            }`}</span>
          </div>
          <div
            className="col col50 pagNav"
            style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
          >
            <button
              id="left-arrow-btn"
              disabled={offset < limit}
              className="btn btnNoTxt btnTeal"
              onClick={async (e) => {
                e.preventDefault();
                if (offset - limit >= 0) {
                  onSetOffset(offset - limit);
                }
              }}
            >
              <i data-testid="forward" className="angle-left-icon icon-64 ti" />
            </button>
            <button
              id="right-arrow-btn"
              disabled={to - offset + 1 < limit}
              className="btn btnNoTxt btnTeal"
              onClick={async (e) => {
                e.preventDefault();
                onSetOffset(offset + limit);
              }}
            >
              <i data-testid="back" className="angle-right-icon icon-64 ti" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
